import { render, staticRenderFns } from "./ExportWallet.vue?vue&type=template&id=06b58cb3&"
import script from "./ExportWallet.vue?vue&type=script&lang=js&"
export * from "./ExportWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports